import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { isMockMode } from './shared/config/runtime-config'
import './styles/globals.css'

const container = document.getElementById('root')
if (!container) throw new Error('Falta el nodo #root en index.html')

/**
 * Con `VITE_USE_MSW=true` el service worker de MSW arranca ANTES del primer
 * render: si montaramos primero, las queries iniciales saldrian a la red real y
 * fallarian antes de que el worker este escuchando.
 */
async function start(): Promise<void> {
  if (import.meta.env.DEV && isMockMode()) {
    const { worker } = await import('./test/msw/browser')
    await worker.start({ onUnhandledRequest: 'bypass', quiet: true })
  }

  createRoot(container!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
